import React, { useState } from "react";
import CollapsibleCard from "../../../ForBrands/ui/CollapsibleCard";
import { SegmentedControl } from "../../../ForBrands/ui/BrandUI";
import { usePhoneTheme } from "../../../ForBrands/useIsPhone";
import { SegmentedControl as PhoneSegmentedControl } from "../../../auth/v2/pieces";
import PercentileRadar, { RADAR_EMPTY, RADAR_GROUPS_LABEL, RADAR_TITLE, radarCaption } from "../PercentileRadar";
import { CardNote } from "./perfPieces";

// The profile's own player radar in the Performance section, where the
// Player Archetype goes when the payload names no archetype and no peer
// group can come for the season (spec B3 b, D4 c: a camp, a short event, a
// league too small; while a group is being built the archetype card's shell
// shows instead). The same groups (League, College, Pro;
// profileModel.radarGroups), the same "Compare with" switch and plot as the
// profile's PlayerRadar / RadarCard, in the section's collapsible card,
// with one line saying why the archetype is not there (`note`,
// athletePerformanceModel.RADAR_FALLBACK_NOTE).

const RadarFallbackCard = ({ groups = [], note = null, cardProps = {} }) => {
  const phone = usePhoneTheme();
  const [picked, setPicked] = useState(null);
  const group = groups.find((g) => g.key === picked) || groups[0] || null;
  return (
    <CollapsibleCard title={RADAR_TITLE} subtitle={group ? radarCaption(group.peerLabel) : null} {...cardProps}>
      <CardNote>{note}</CardNote>
      {groups.length > 1 &&
        (phone ? (
          <PhoneSegmentedControl label={RADAR_GROUPS_LABEL} value={group.key} onChange={setPicked} options={groups.map((g) => [g.key, g.tab])} />
        ) : (
          <div role="group" aria-label={RADAR_GROUPS_LABEL} className="flex">
            <SegmentedControl value={group.key} onChange={setPicked} options={groups.map((g) => ({ value: g.key, label: g.tab }))} />
          </div>
        ))}
      {group ? (
        <div className="flex justify-center">
          <PercentileRadar axes={group.radar} peerLabel={group.peerLabel} />
        </div>
      ) : (
        <p className="bm-body-s text-bm-muted">{RADAR_EMPTY}</p>
      )}
    </CollapsibleCard>
  );
};

export default RadarFallbackCard;
